import React from "react";
import { Card } from "react-bootstrap";
import user from "../../assets/img/user_card.png";
import admin_role from "../../assets/img/admin_role.png";
import username from "../../assets/img/username.png";
import mail from "../../assets/img/mail.png";
import dots from "../../assets/img/dots.png";
import editIcon from "../../assets/img/compact-menu-edit.png";
import reportPermission from "../../assets/img/report_permission.png";
import { useHistory } from "react-router-dom";

const User = (props) => {
  const { name, surname, id, email, role } = props.user;
  const { openUpdateModal } = props;
  let historyy = useHistory();

  let history = useHistory();

  const cardTitleHandler = (name, surname) => {
    return !name || !surname || ""
      ? "Name Or Surname Has Not Found"
      : name + " " + surname;
  };

  const emailAreaHandler = (email) => {
    return !email ? "Email has not found" : email;
  };

  const renderUserRoleImg = () => {
    if (role == "ADMIN") {
      return (
        <Card.Img
          variant="top"
          src={admin_role}
          style={{
            width: "48px",
            height: "48px",
            margin: "10px auto 3px",
            display: "block",
          }}
        />
      );
    } else {
      return (
        <Card.Img
          variant="top"
          src={user}
          style={{
            width: "48px",
            height: "48px",
            margin: "10px auto 3px",
            display: "block",
          }}
        />
      );
    }
  };

  const reportDefinitionClick = (id, username) => {
    historyy.push(`/user/permissions?id=${id}&name=${username}`);
  };

  const renderActions = (id, name, username) => {
    return (
      <div className="compact-menu-user">
        <img src={dots} alt="dots" className="compact-menu-user-dots" />
        <div className="compact-menu-user-content">
          <ul>
            <li>
              <div onClick={() => reportDefinitionClick(id, username)}>
                <img src={reportPermission} alt="permission" />
                <span style={{ fontSize: "13px" }}>Report Permissions</span>
              </div>
            </li>
            <li>
              <div onClick={() => openUpdateModal(props.user)}>
                <img src={editIcon} alt="edit" />
                <span style={{ fontSize: "13px" }}>Edit</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    );
  };

  return (
    <Card style={{ overflow: "hidden" }}>
      {renderActions(id, name, username)}
      {renderUserRoleImg()}
      <Card.Body style={{ paddingTop: "0" }}>
        <Card.Title id="userCardTitle" title={cardTitleHandler(name, surname)}>
          {cardTitleHandler(name, surname)}
        </Card.Title>
        <div style={{ display: "inline-flex" }} title={props.user.username}>
          <img src={username} className="userCardIcon" />
          <span className="userCardText">{props.user.username}</span>
        </div>
        <br />
        <div style={{ display: "inline-flex" }} title={emailAreaHandler(email)}>
          <img src={mail} className="userCardIcon" />
          <span className="userCardText">{emailAreaHandler(email)}</span>
        </div>
      </Card.Body>
    </Card>
  );
};

export default User;
